import { render, staticRenderFns } from "./integralRuleConfig.vue?vue&type=template&id=4ba755d0&scoped=true"
import script from "./integralRuleConfig.vue?vue&type=script&lang=js"
export * from "./integralRuleConfig.vue?vue&type=script&lang=js"
import style0 from "./integralRuleConfig.vue?vue&type=style&index=0&id=4ba755d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba755d0",
  null
  
)

export default component.exports